import { apiCaller } from '../ApiCaller/ApiCaller';

export async function updateCaseDataOfContact(caseData) {

    const updateCaseData  = apiCaller("https://salesforceb2b.customers.bigfivecrm.com/updateCaseDetail", caseData);

      return updateCaseData;
}